import React from 'react';
import { Loader2 } from 'lucide-react';

/** Thin inline indicator shown while a filter/sort/page change is in flight.
 * Deliberately NOT a full-page loader — the table/card list underneath stays
 * mounted and visible (just dimmed by the caller via TABLE_DIM_CLASS) so
 * nothing blinks or remounts. */
export const TableLoadingBar: React.FC<{ show: boolean; label?: string }> = ({ show, label = 'Updating results…' }) => {
    if (!show) return null;
    return (
        <div className="flex items-center gap-2 px-4 py-2 text-xs text-muted-foreground sm:px-6">
            <Loader2 className="h-3 w-3 animate-spin" /> {label}
        </div>
    );
};

/** Applied to the table/card-list container while a background refetch is in
 * flight — dims content without unmounting it. */
export const TABLE_DIM_CLASS = 'opacity-60 pointer-events-none transition-opacity';
